import { render, staticRenderFns } from "./NsFooter.vue?vue&type=template&id=38d10133&scoped=true"
import script from "./NsFooter.vue?vue&type=script&lang=js"
export * from "./NsFooter.vue?vue&type=script&lang=js"
import style0 from "./NsFooter.vue?vue&type=style&index=0&id=38d10133&prod&scoped=true&lang=scss"
import style1 from "./NsFooter.vue?vue&type=style&index=1&id=38d10133&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d10133",
  null
  
)

export default component.exports